import React from "react";
import PropTypes from "prop-types";
import Prism from "prismjs";

/**
 * Runs the given code through prismjs, and renders the resulting HTML.
 * No CSS is provided - the prismjs CSS is global because it is also
 * used by the gatsby-remark-prismjs plugin.
 */
class SyntaxHighlight extends React.Component {
  getHighlightedCode() {
    const grammar = Prism.languages[this.props.language];
    if (!grammar) {
      throw new Error(
        `Invalid language specified in <SyntaxHighlight/>. Language:${
          this.props.language
        }`
      );
    }
    return Prism.highlight(this.props.code.trim(), grammar);
  }

  render() {
    if (!this.props.code) {
      return null;
    }
    return (
      <div className="gatsby-highlight">
        <pre className={`language-${this.props.language}`}>
          <code
            dangerouslySetInnerHTML={{ __html: this.getHighlightedCode() }}
          />
        </pre>
      </div>
    );
  }
}
SyntaxHighlight.propTypes = {
  code: PropTypes.string,
  language: PropTypes.string
};
SyntaxHighlight.defaultProps = {
  code: null,
  language: `javascript`
};
export default SyntaxHighlight;



// WEBPACK FOOTER //
// ./src/components/common/SyntaxHighlight.js